import { createContext, useContext } from 'react';

import type { USPItemProps } from '@widget/components';
import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';

type Props = {
  uspTextItems?: USPItemProps[] | undefined | null;
  localizedUspLabel?: string | undefined | null;
};

const UspTextContext = createContext<Props>({} as Props);

export const UspTextProvider: ReactFCWithChildren<Props> = ({
  uspTextItems,
  localizedUspLabel,
  children,
}) => {
  return (
    <UspTextContext.Provider value={{ uspTextItems, localizedUspLabel }}>
      {children}
    </UspTextContext.Provider>
  );
};

export const useUspText = (): Props => {
  return useContext(UspTextContext);
};
